const config = {
  appleServiceId:
    process.env.REACT_APP_APPLE_SERVICE_ID ||
    process.env.SIGN_IN_WITH_APPLE_SERVICE_ID ||
    "",
  appleRedirectUri:
    process.env.REACT_APP_APPLE_REDIRECT_URI ||
    (typeof globalThis === "undefined"
      ? ""
      : globalThis.location.origin + "/apple-redirect"),
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "",
  mapKitToken: process.env.REACT_APP_MAPKIT_TOKEN || "",
};

export default config;
